import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ColorPickerModule } from 'ngx-color-picker';

@Component({
  selector: 'app-new-palette',
  standalone: true,
  imports: [ColorPickerModule, CommonModule,
      MatDialogModule,
      MatButtonModule,
      MatFormFieldModule,
      MatInputModule,
      FormsModule,
      MatIconModule,],
  templateUrl: './new-palette.component.html',
  styleUrl: './new-palette.component.scss'
})
export class NewPaletteComponent {
  constructor(
    private dialogRef: MatDialogRef<NewPaletteComponent, any>,
    
  ) { }
  color1: string;
  color2: string;
  color3: string;
  color4: string;
  color5: string;
  organizationId?: number;
  id?: number;

  validColor(){
    // Si au moins une couleur
    if(this.color1 != null ){
      this.dialogRef.close(true);
    }
  }
}
